import { AdminApi } from 'stylemix-vue-admin'

export default class AccountApi extends AdminApi {
  constructor(parameters) {
    super('account', parameters)
  }

  profileForm() {
    return this.submit('GET', `${this.endpoint}/profile`)
  }

  saveProfile(data) {
    return this.submit('PUT', `${this.endpoint}/profile`, data)
  }
}
